import { createSelector } from "@reduxjs/toolkit";
import { IRootState } from "../../../../redux/root.reducer";

export const tooltipsSelector = createSelector(
    (state: IRootState) => state.userPreferences.tooltips.data ?? [],
    (tooltips) =>
        tooltips.reduce(
            (acc, tooltip) => {
                acc[tooltip.id] = tooltip.content;
                return acc;
            },
            {} as Record<string, string>,
        ),
);
